import { render, staticRenderFns } from "./LogCustomPayrate.vue?vue&type=template&id=2744f4d9&"
import script from "./LogCustomPayrate.vue?vue&type=script&lang=js&"
export * from "./LogCustomPayrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports